class ArchivePicklist {
    constructor(Alert, $http, $state, $stateParams, SweetAlert, $translate) {
        this.key = 'archive-picklist';
        this.title = 'Archive';
        this.level = 'highlight';
        this.icon = 'fal fa-trash-alt';
        this.alert = Alert;
        this.sweetAlert = SweetAlert;
        this.api = $http;
        this.order = 15;
        this.state = $state;
        this.back = $stateParams.back;
        this.params = $stateParams.backParams || {
            id: $stateParams.id
        };
        this.translate = $translate;
    }

    action({}, store) {
        const translatedValue = (path, params) => {
            return this.translate.instant(`picklists.workflows.ask-to-archive-picklist.${path}`, params);
        };

        this.alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content', {picklist_name: store.state.vm.picklist.name}),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
            },
        ).then(() => {
            return this.api.delete(`picklists/${ store.state.vm.picklist.id }`, {data: {force: false}})
                .then(() => {
                    this.alert.success('Success', 'Picklist archived');
                    return this.state.go(this.back, this.params);
                }, err => this.alert.handle(err));
        }, () => ({}))
    }

}

angular
    .module('festzelt-os.picklists')
    .factory('archivePicklist', [
        'Alert',
        '$http',
        '$state',
        '$stateParams',
        'SweetAlert',
        '$translate',
        (Alert, $http, $state, $stateParams, SweetAlert, $translate) => new ArchivePicklist(Alert, $http, $state, $stateParams, SweetAlert, $translate)
    ]);




// WEBPACK FOOTER //
// ./src/app/pages/picklists/workflows/general/archive-picklist.js